import {Component, Injector} from "@angular/core";
import {provideSearchModel} from "@fedeltapointofsale/data-client";
import {ExtraSearchModel} from "../extra-search.model";
import {
    registerSelectEditControl
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-select-edit-control.component";
import {ExtraSearchPageComponent} from "../extra-search-page/extra-search-page.component";
import {ExtraEditPageComponent} from "../extra-edit-page/extra-edit-page.component";
import {
    AbstractMultiSelectEditControlComponent
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-multi-select-edit-control.component";

@Component({
    selector: "wbo-extra-multi-select-edit-control",
    templateUrl: "../../../framework/entity/edit/edit-controls/select-edit-controls/multi-select-edit-control.component.html",
    providers: [
        provideSearchModel(ExtraSearchModel),
        registerSelectEditControl(ExtraMultiSelectEditControlComponent)
    ]
})
export class ExtraMultiSelectEditControlComponent extends AbstractMultiSelectEditControlComponent<ExtraSearchModel> {
    constructor(model: ExtraSearchModel, injector: Injector) {
        super(model, injector, "id", "name");

        this.extendedSearchComponent = ExtraSearchPageComponent;
        this.extendedEditComponent = ExtraEditPageComponent;
    }
}
